// extracted by mini-css-extract-plugin
export default {"Accordion":"styles_Accordion__NdUTm"};